
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.971 8.137a.364.364 0 00-.081-.402l-6.75-6.632a.38.38 0 00-.53.01.364.364 0 000 .511l6.11 6.003H1.375A.372.372 0 001 7.996c0 .203.168.368.375.368H25.72l-6.11 6.003a.364.364 0 00-.009.52.38.38 0 00.54 0l6.75-6.631a.369.369 0 00.08-.12z"}})])
          )
        }
      }
    